module.exports = __webpack_public_path__ + "media/after_dark.9a4ab24e.mp3";